module.exports = __webpack_public_path__ + "img/terroir-moonlit-4.604b5b70.jpg";